import { redirectToWsLogin } from "./RedirectToLogin";
import type { TGetInfoAboutHostingResponse } from "@eway-crm/hostingdaemon-js-lib";
import type { TUserToCreate } from "../pages/FinalizationPage/Finalization/Finalization";
import RedirectToImportContactsFromO365Page from "./RedirectToImportContactsFromO365Page";

type loginParamsObject = {
    client_id: string;
    redirect_uri: string;
    scope: string;
    response_type: string;
    code_challenge?: string;
    code_challenge_method?: string;
};

const hasNecesarryAuthParams = (val: Record<string, string>): val is loginParamsObject => {
    if ("client_id" in val && "redirect_uri" in val && "scope" in val && "response_type" in val)
        return true;

    return false;
};

export const finalRedirect = (urlParams: URLSearchParams | null, hostingInfo: TGetInfoAboutHostingResponse, accountsInfo: TUserToCreate[], outlookType: string[], isLoggedViaMs: boolean, wcfVersion: string | undefined, language: string, failedCallback: () => void) => {
    const loginParams = Object.fromEntries(urlParams?.entries() ?? []);

    if (hasNecesarryAuthParams(loginParams)) {
        redirectToWsLogin(
            hostingInfo.eWayWebServiceUrl,
            accountsInfo[0].username,
            loginParams.client_id,
            loginParams.redirect_uri,
            loginParams.scope,
            loginParams.response_type,
            loginParams.code_challenge,
            loginParams.code_challenge_method
        );
    } else {
        RedirectToImportContactsFromO365Page(
            hostingInfo,
            accountsInfo,
            outlookType,
            isLoggedViaMs,
            wcfVersion,
            language,
            failedCallback
        );
    }
};